
export default {
  name: 'AppDropdown',
  props: {
    arrow: Boolean,
    openTop: Boolean,
    disableCloseOnSelect: Boolean,
    selectionMode: Boolean,
    buttonRounded: Boolean,
    customLabel: Boolean,
    items: {
      type: Array,
      default () {
        return []
      }
    },
    value: {
      type: [String, Number],
      default: ''
    },
    listClass: {
      type: String,
      default: 'w-full top-9 w-max'
    },
    buttonClass: {
      type: String,
      default: 'text-left w-full px-4 py-2'
    }
  },
  data () {
    return {
      isOpen: false,
      activeItem: this.value
    }
  },
  computed: {
    itemClass () {
      return [
        'relative block px-4 py-1.5',
        !this.selectionMode && 'cursor-pointer'
      ]
    },
    dropdownItems () {
      const items = []

      for (const item of this.items) {
        items.push({
          ...item,
          selected: this.activeItem === item.key
        })
      }

      return items
    }
  },
  watch: {
    value () {
      this.activeItem = this.value
    }
  },
  methods: {
    close () {
      this.isOpen = false
    },
    toggle () {
      this.isOpen = !this.isOpen
    },
    clickItem (item) {
      this.$emit('input', typeof item === 'string' ? item : item.key)

      if (!this.customLabel) {
        this.$emit(typeof item === 'string' ? item : item.key)
      }

      if (!this.disableCloseOnSelect) {
        this.close()
      }
    }
  }
}
